// extracted by mini-css-extract-plugin
export default {"featuredContainer":"Shop_featuredContainer__cJnKb","content":"Shop_content__nCFI2","imageCont":"Shop_imageCont__2+kn2","shopBtn":"Shop_shopBtn__Qp-yI","heru":"Shop_heru__Y2OPH"};